/** Returns the possessive of word, being it either singular or plural. */
export function formatPossessive(word: string): string {
  if (word.charAt(word.length - 1) === 's') {
    return `${word}’`;
  } else {
    return `${word}’s`;
  }
}
